import React from 'react';
import { Button, Container } from 'react-bootstrap';
import { BsArrowRight } from "react-icons/bs";
import './Special.css'
const Special = () => {
    return (
        <div className='section-container special'>
            <Container>
                <div className="special-banner">
                    <div className="row align-items-center">
                        <div className="col-12 col-md-12 col-lg-6">
                            <div className="section-heading">
                            <span>Save Your Money</span>
                            <h2>Buy Now & Save Upto 33%</h2>
                            </div>
                            <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Odio totam, repellat aliquam illo velit quidem fugiat est, repudiandae earum consequuntur ut aspernatur magni quos voluptates iure eos voluptatibus sequi commodi numquam facere! Vitae, laudantium nihil?</p>
                            <Button className="btn-md btn-light">View All <BsArrowRight className="ms-1"/></Button>
                        </div>
                        <div className="col-12 col-md-12 col-lg-6">
                            <img src={require('../../../images/specials/special1.png')} alt="" className="w-100" />
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default Special;